import { Tabs } from '@seiue/ui'
import React, { useContext } from 'react'
import styled from 'styled-components'
import { ButtonRender } from './ButtonRender'
import { CommonTopic } from './utils'
import { QuestionnaireContext } from './context'

/**
 * 问卷 - 工具栏区域（通用字段|用户字段）
 * @returns React.ReactNode
 */
export const ToolBar: React.FC = () => {
  const { userFieldsConfig } = useContext(QuestionnaireContext)
  return (
    <Wrapper>
      <Tabs
        centered
        items={[
          {
            label: '通用题目',
            key: '1',
            children: (
              <ButtonRender
                isCommonField
                configs={CommonTopic}
              />
            ),
          },
          {
            label: '用户字段',
            key: '2',
            children: <ButtonRender configs={userFieldsConfig} />,
          },
        ]}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 280px;
  min-width: 280px;
  height: 100%;
  box-shadow: 0px 0px 1px 0px rgba(21, 29, 41, 0.2),
    0px 3px 8px -1px rgba(21, 29, 41, 0.04);
  &&& {
    .ant-tabs-nav {
      height: 54px;
      padding: 0 20px;
      margin-bottom: 0;
    }
    .ant-tabs-tab {
      width: 104px;
      padding: 16px 0 !important;
      & .ant-tabs-tab-btn {
        font-size: 14px;
        font-weight: 400;
        color: ${(props) => props.theme.text._2};
      }
    }
    .ant-tabs-tabpane {
      height: calc(100vh - 174px);
      padding-top: 20px;
      overflow: auto;
      ::-webkit-scrollbar {
        display: none;
      }
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${(props) => props.theme.brand._1};
    }
  }
`
